import * as THREE from "three";
import { FontLoader } from "three/examples/jsm/loaders/FontLoader";
import { TextGeometry } from "three/examples/jsm/geometries/TextGeometry";
import Experience from "../Experience";
import vertexShader from "./shaders/vertex.glsl";
import fragmentShader from "./shaders/fragment.glsl";

export default class World {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.timeline = this.experience.animation.timeline;
    this.time = this.experience.time;

    this.amount = 0.2;
    this.plane;
    this.material;
    this.fontLoader;
    this.textMaterial;
    this.isLoaded = false;
    this.CONFIG = {
      fontColor: "#ffffff",
    };

    // this.colorsFolder = this.debug.pane.addFolder({ title: "Colors" });
    // this.meshFolder = this.debug.pane.addFolder({ title: "Noise" });

    this.setColors();
    this.initGradient();
    this.setTitle();
  }
  setColors() {
    this.colors = ["#ffffff", "#EF008F", "#6EC3F4", "#7038FF", "#FFBA27"];
    this.colors = this.colors.map((color) => new THREE.Color(color));
  }

  initGradient() {
    this.material = new THREE.ShaderMaterial({
      vertexShader: vertexShader,
      fragmentShader: fragmentShader,
      uniforms: {
        uFrequency: { value: new THREE.Vector2(3, 6) },
        uTime: { value: 0 },
        uColor: { value: this.colors },
        uAmount: { value: this.amount },
        uSpeed: { value: 0.02 },
      },
      // wireframe: true,
    });
    this.geometry = new THREE.PlaneGeometry(1.5, 1.5, 150, 150);

    this.plane = new THREE.Mesh(this.geometry, this.material);

    this.scene.add(this.plane);
  }

  setTitle() {
    this.fontLoader = new FontLoader();
    this.fontLoader.load("/fonts/Cabinet_Medium.json", (font) => {
      this.isLoaded = true;

      const textGeometry = new TextGeometry("Distant Creative Collaboration", {
        font: font,
        size: 0.03,
        height: 0,
        curveSegments: 12,
        // bevelEnabled: true,
        // bevelThickness: 0.03,
        // bevelSize: 0.02,
        // bevelOffset: 0,
        // bevelSegments: 5,
      });
      this.textMaterial = new THREE.MeshBasicMaterial({
        // depthTest: false,
        transparent: true,
        color: 0xffffff,
      });
      this.text = new THREE.Mesh(textGeometry, this.textMaterial);
      textGeometry.center();
      this.text.position.z += 0.008;

      textGeometry.rotateX(Math.PI * 0.2);

      // this.text.renderOrder = 1;
      // this.titleColor = this.colorsFolder.addInput(this.textMaterial, "color", {
      //   color: { type: "float" },
      //   picker: "inline",

      //   label: "title color",
      // });
      if (window.innerWidth < 1200) {
        this.text.visible = false;
        // this.titleColor.hidden = true;
      } else {
        this.text.visible = true;
        // this.titleColor.hidden = false;
      }

      this.scene.add(this.text);
      this.addAnimations();
    });
  }

  setDebug() {
    for (let color in this.colors) {
      this.colorsFolder.addInput(this.colors, color, {
        color: { type: "float" },
        picker: "inline",

        label: `color${color}`,
      });
    }

    const root = document.documentElement;

    this.meshFolder.addInput(this.material.uniforms.uAmount, "value", {
      min: 0,
      max: 0.6,
      step: 0.01,
      label: "amount",
    });
    this.meshFolder.addInput(this.material.uniforms.uFrequency.value, "x", {
      min: 0,
      max: 7,
      step: 0.01,
      label: "frequency",
    });
    this.meshFolder.addInput(this.material.uniforms.uSpeed, "value", {
      min: 0,
      max: 0.3,
      step: 0.01,
      label: "speed",
    });
  }

  addAnimations() {
    this.timeline.to(this.textMaterial, { opacity: 0 }, "start").to(
      this.material.uniforms.uAmount,
      {
        value: 0.0,
      },
      "start"
    );
    // .to(this.material.uniforms.uFrequency.value, { x: 0.0 }, "start");
  }

  update() {
    this.material.uniforms.uTime.value = this.time.elapsed * 0.001;
  }
  resize() {
    if (window.innerWidth < 1200) {
      this.text.visible = false;
      // this.titleColor.hidden = true;
    } else {
      this.text.visible = true;
      // this.titleColor.hidden = false;
    }
  }
}
